<template>
  <div>
    <FormulateInput
      v-if="personalizedType !== 'clipartCategory'"
      :name="layer.id"
      :label="label"
      :layer="layer"
      :configsMoonPhase="configsMoonPhase"
      type="imagemoonphase"
      :artwork="artwork"
      :aspectRatio="aspectRatio"
      @changeTextMoonPhase="ChangeTextMoonPhase"
    />
  </div>
</template>

<script>
  import { get } from 'lodash'
  export default {
    name: "ImageMoonPhaseField",
    props: {
      layer: {
        type: Object,
        required: true
      },
      artwork: {
        type: Object,
        required: true
      },
      personalized: {
        type: Object,
        default() {
          return {}
        }
      }
    },
    mounted() {
    },
    methods: {
      ChangeTextMoonPhase(data){
        this.$emit('changeTextMoonPhase', data)
      }
    },
    computed: {
      personalizedType() {
        return this.layer.personalized.type
      },
      required() {
        return get(this.layer, 'personalized.required', false)
      },
      initialValue() {
        const { personalized, layer } = this
        return get(personalized, layer.id)
      },
      configsMoonPhase(){
        return get(this.layer, 'configsMoonPhase', {})
      },
      label() {
        return get(this.layer, 'personalized.label', this.layer.title)
      },
      aspectRatio() {
        const { layer } = this
        return layer.width / layer.height
      }
    },

  }
</script>



// WEBPACK FOOTER //
// src/components/Form/ImageMoonPhaseField.vue